import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h2>The Page Is Not Found</h2>
    </div>
  );
};

export default ErrorPage;
